import { ZRMUserInfo } from '@zg-rentals/analytics';

import type { ClickstreamEvent, User } from '@zg-rentals/analytics';

// https://dataportal.zillowgroup.net/event-registry/3626
const AreaSearch = ({ user }: { user: User }): ClickstreamEvent => ({
  envelope: {
    event_template_id: '167',
    event_template_version_id: '1',
    event_type_id: '3626',
    event_type_version_id: '1',
  },
  clickstream_trigger: {
    trigger_location_nm: 'zrm_market_trends_start_page',
    trigger_type_nm: 'interaction',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'market_trends_area_search',
  },
  semantic: {
    semantic_event_nm: 'zrm_market_trends',
    topic_tag_txt: ['zrm_growth'],
  },
  zrm_user_info: ZRMUserInfo(user),
});

// https://dataportal.zillowgroup.net/event-registry/3629
const ViewTopMarket = ({ user }: { user: User }): ClickstreamEvent => ({
  envelope: {
    event_template_id: '167',
    event_template_version_id: '1',
    event_type_id: '3629',
    event_type_version_id: '1',
  },
  clickstream_trigger: {
    trigger_location_nm: 'zrm_market_trends_start_page',
    trigger_type_nm: 'interaction',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'market_trends_view_top_market',
  },
  semantic: {
    semantic_event_nm: 'zrm_market_trends',
    topic_tag_txt: ['zrm_growth'],
  },
  zrm_user_info: ZRMUserInfo(user),
});

// https://dataportal.zillowgroup.net/event-registry/3630
const ExploreRentals = ({ user }: { user: User }): ClickstreamEvent => ({
  envelope: {
    event_template_id: '167',
    event_template_version_id: '1',
    event_type_id: '3630',
    event_type_version_id: '1',
  },
  clickstream_trigger: {
    trigger_location_nm: 'zrm_market_trends_results_page',
    trigger_type_nm: 'interaction',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'market_trends_explore_market',
  },
  semantic: {
    semantic_event_nm: 'zrm_market_trends',
    topic_tag_txt: ['zrm_growth'],
  },
  zrm_user_info: ZRMUserInfo(user),
});

const MarketTrendsCSEvents = {
  AreaSearch,
  ExploreRentals,
  ViewTopMarket,
};

export default MarketTrendsCSEvents;
